import { FunctionComponent, useMemo } from "react";
import { sanitize } from "isomorphic-dompurify";

interface Props {
  html?: string;
  id?: string;
}

const HTMLRichText: FunctionComponent<Props> = ({ html, id }) => {
  const sanatizedHtml = useMemo(
    () => sanitize(html || "", { ADD_ATTR: ["target"] }),
    [html],
  );

  if (!sanatizedHtml) {
    return null;
  }

  return (
    <p
      id={id}
      dangerouslySetInnerHTML={{
        __html: sanatizedHtml,
      }}
    />
  );
};

export default HTMLRichText;
